<template>
    <div>
        {{ $t('notification.userPhoneChanged', { 
            actor: $_.get(activity, 'actorUser.name'), 
            userName: $_.get(activity, 'payload.userName'),
            oldPhone: $_.get(activity, 'payload.oldPhone'),
            newPhone: $_.get(activity, 'payload.newPhone')
        }) }}
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserPhoneChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

